import React from "react";

import { mediaQueriesV2 } from "@ui/themes/default";

import { useTranslate } from "@hooks/useTranslate";

import imageDesktop from "../assets/hero_desktop.webp";
import imageTablet from "../assets/hero_tablet.webp";
import imageMobile from "../assets/hero_mobile.webp";

import * as Styled from "./Image.styled";

export const Image: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root>
      <Styled.Image
        width={1130}
        height={1676}
        src={imageMobile}
        alt={translate("hero_image_alt")}
        loading="eager"
        sources={[
          {
            media: mediaQueriesV2.largeMobile,
            srcSet: imageMobile,
          },
          {
            media: mediaQueriesV2.smallTablet,
            srcSet: imageTablet,
          },
          {
            media: mediaQueriesV2.tablet,
            srcSet: imageTablet,
          },
          {
            media: mediaQueriesV2.smallDesktop,
            srcSet: imageDesktop,
          },
          {
            media: mediaQueriesV2.desktop,
            srcSet: imageDesktop,
          },
          {
            media: mediaQueriesV2.largeDesktop,
            srcSet: imageDesktop,
          },
        ]}
      />
    </Styled.Root>
  );
};
